import { t } from './index';

const INFO_SHARE_STATUS_KEYS: Record<string, string> = {
  Pending: 'info.status.pending',
  Opened: 'info.status.opened',
  Expired: 'info.status.expired',
  Revoked: 'info.status.revoked',
  Purged: 'info.status.purged',
  Active: 'files.status.active',
};

export function tInfoShareStatus(status: string): string {
  const key = INFO_SHARE_STATUS_KEYS[status];
  return key ? t(key) : status;
}
